import { render, staticRenderFns } from "./CompanyArticle.vue?vue&type=template&id=0a974f23"
import script from "./CompanyArticle.vue?vue&type=script&lang=js"
export * from "./CompanyArticle.vue?vue&type=script&lang=js"
import style0 from "./CompanyArticle.vue?vue&type=style&index=0&id=0a974f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports